import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { fetchLocationStatuses } from './locationStatusApi';

export function useLocationStatuses(accessToken, { enabled, rows, requests }) {
  const [statuses, setStatuses] = useState([]);
  const [userStatuses, setUserStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const generation = useRef(0);

  const refresh = useCallback(async () => {
    const currentGeneration = ++generation.current;
    if (!accessToken || !enabled) {
      setStatuses([]);
      setUserStatuses([]);
      setLoading(false);
      setError('');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const result = await fetchLocationStatuses(accessToken);
      if (currentGeneration === generation.current) {
        setStatuses(Array.isArray(result?.statuses) ? result.statuses : []);
        setUserStatuses(Array.isArray(result?.userStatuses) ? result.userStatuses : []);
      }
    } catch (requestError) {
      if (currentGeneration === generation.current) {
        setStatuses([]);
        setUserStatuses([]);
        setError(requestError.message || 'No se pudo consultar el estado de las sedes.');
      }
    } finally {
      if (currentGeneration === generation.current) setLoading(false);
    }
  }, [accessToken, enabled]);

  useEffect(() => {
    refresh();
    return () => { generation.current += 1; };
  }, [refresh, rows, requests]);

  return useMemo(() => ({ statuses, userStatuses, loading, error, refresh }), [statuses, userStatuses, loading, error, refresh]);
}
